import { checkPermissionRoleScreen } from '../main';

function createRoute(path, name, typeRole, component) {
    return {
        path: path,
        name: name,
        beforeEnter: (to, from, next) => {
            return next(checkPermissionRoleScreen(typeRole));
        },
        component: component
    };
}
const routes = [
    createRoute('/setting', 'setting', 'type_admin', () => import('@/views/setting/list')),
    createRoute('/setting-kintone', 'settingKintone', 'type_admin', () => import('@/views/kintoneSetting/list'))
];
export default routes;
